<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="活动名称" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="dataSearch"></el-button></el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="create_time" type="daterange" value-format="yyyy/MM/dd" placeholder="添加时间筛选" style="width: 100%;" @change="dateChange"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="addActivityData">添加活动</el-button>
        </el-col>
      </el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>

        <el-table :data="activityLists" :height="wheight-200" v-loading="loading">
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column prop="name" label="活动名称" min-width=""></el-table-column>
          <el-table-column label="平台类型" min-width="">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.platform === 'online'" type="primary">线上</el-tag>
              <el-tag v-else-if="scope.row.platform === 'pos'" type="success">线下</el-tag>
              <el-tag v-else type="info">{{ scope.row.platform }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="">
            <!-- <template slot-scope="scope">
              <el-switch  v-model="scope.row.is_qy" active-value="0"  inactive-value="1"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChange(scope.$index, scope.row)"></el-switch>
            </template> -->
            <template slot-scope="scope">
              <el-switch  v-model="scope.row.is_qy"  
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0" @change="defaultSwitchChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="活动时间" min-width="">
            <template slot-scope="scope">
              <div> {{scope.row.begin | datetime('yyyy-MM-dd hh:mm:ss')}}</div>
              <div>~</div>
              <div>{{scope.row.end | datetime('yyyy-MM-dd hh:mm:ss')}}</div>
            </template>
          </el-table-column>
          <el-table-column label="预览" min-width="">
            <template slot-scope="scope">
              <el-button type="primary" @click="prelink(scope.row.id)">生成预览链接</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <el-button type="text" @click="editAction(scope.$index, scope.row)">编辑活动</el-button>
              <el-button type="text" @click="toActivity(scope.row.id)">查看中奖记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10,20,50]"
            :current-page.sync="params.page"
            :total="total_count" :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import { getLotteryActivitysList,updateStatus,changeShowOne} from '../../../../api/promotions'
export default {
  props: ['getStatus'],
  provide() {
    return {
      refresh: this.refresh
    }
  },
  data () {
    return {
      create_time: '',
      activeName: 'all',
      activityLists: [],
      downloadfilename: '',
      downloadUrl: '',
      loading: false,
      total_count: 0,
      params: {
        page: 1,
        pageSize: 20,
        status: '',
        title: '',
        begin_time: '',
        end_time: '',
      },
      communityVisible: false,
      currency: {}
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {

    handleClick(tab, event) {
      this.activeName = tab.name
      this.params.status = tab.name == 'all' ? '' : tab.name
      this.params.page = 1
      this.getActivityLists()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getActivityLists()
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getActivityLists()
    },
    addActivityData () { // 添加物料弹框
      this.$router.push({path: this.matchHidePage('editor')})
    },
    editAction (index, row) { // 编辑物料弹框
      this.$router.push({path: this.matchHidePage('editor/') + row.id})
    },
    copyAction (index, row) { // 复制活动
     // this.$router.push({path: this.matchHidePage('editor/') + row.seckill_id})
      this.$router.push({path: this.matchHidePage('editor/?copy_seckill_id=') + row.seckill_id})
    },
    changeShow(index, id){
      var msg = '确定隐藏, 是否继续?'
      this.$confirm(msg, '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            changeShowOne({seckill_id:id}).then(response => {
              if(response.data.data.status==1){
                this.$message({
                  message: response.data.data.message,
                  type: 'success',
                  duration: 2000
                })
                this.getActivityLists()
              }else{
                this.$message({
                  message: response.data.data.message,
                  type: 'error',
                  duration: 2000
                })
              }
            })
          }
          done()
        }
      })
    },
    dataSearch() {
      this.params.begin_time = ''
      this.params.end_time = ''
      this.params.page = 1
      this.getActivityLists()
    },
    getActivityLists () {
      this.loading = true
      getLotteryActivitysList(this.params).then(response => {
        this.activityLists = response.data.data.list
        this.total_count = response.data.data.total_count
        this.loading = false
      })
    },
    toActivity(activity_id) {
      this.$router.push({path: '/marketing/Activitys_log?ac_id=' + activity_id})
    },
    defaultSwitchChange (row) {
      console.log(row,'22222222222222222222')
        updateStatus(row.id, {is_qy: row.is_qy}).then(response => {
          this.$message({ type: 'success', message: '操作成功'})
        })
    },
    prelink(id){
      console.log(id,'5566666666')
      window.open('https://h5.yaoking.cn/pages/special/draw/turntableJf?drawid=' + id)
    },
    dateChange (val) {
      this.params.status = ''
      if (val && val.length > 0) {
        this.params.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.begin_time = ''
        this.params.end_time = ''
      }
      this.params.page = 1
      this.getActivityLists()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    editAction (index, row) { // 编辑物料弹框
      this.$router.push({path: this.matchHidePage('editor/') + row.id})
    },
    handleCancel () {
      this.communityVisible = false
    },
    refresh () {
      this.getActivityLists()
    }
  },
  mounted () {
    this.getActivityLists()
  },
  watch: {
    getStatus (val) {
      if (val) {
        this.getActivityLists()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.icon-search-plus {
  cursor: pointer;
}
.text-muted {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// list.vue?30cafb20